export enum PreventionActionsEnum {
  PREVENTION_GET_KNMS = 'PREVENTION_GET_KNMS',
  PREVENTION_SET_ORDER = 'PREVENTION_SET_ORDER',
  PREVENTION_SET_DATA = 'PREVENTION_SET_DATA',
  PREVENTION_SET_SEARCH_VALUE = 'PREVENTION_SET_SEARCH_VALUE',
  PREVENTION_DELETE_KNMS = 'PREVENTION_DELETE_KNMS',
  PREVENTION_GET_KNMS_NEXT_PAGE = 'PREVENTION_GET_KNMS_NEXT_PAGE',
  PREVENTION_LIST_EXPORT_PREVENTIONS = 'PREVENTION_LIST_EXPORT_PREVENTIONS',
  PREVENTION_GET_PM_SELECT_OPTIONS = 'PREVENTION_GET_PM_SELECT_OPTIONS',
}
